import React, { useEffect, useState, useContext } from "react";
import { ContextAuth } from "../../../contexts/ContextAuth";
import { Card } from "../../../components/ui";
import { WarehouseList } from "../fragments.logistics/WarehouseList";
import { WarehouseRegisterForm } from "../fragments.logistics/WarehouseRegisterForm";

import {
    fetchedWarehousesWithoutProducts,
    fetchedWarehouseCategories,
} from "../../../apis/apis.logistics/apisProduct";

const emptyWarehouse = {
    warehouseID: 0,
    warehouseName: "",
    subsidiaryID: "",
    subsidiaryName: "",
    warehouseCategory: "",
    warehouseCategoryDisplay: "",
    productDict: [],
};

export function WarehousePage() {
    const { auth } = useContext(ContextAuth);
    const [warehouses, setWarehouses] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState(emptyWarehouse);
    const [warehouseCategories, setWarehouseCategories] = useState([]);
    const [isWarehouseModalOpen, setIsWarehouseModalOpen] = useState(false);

    const openWarehouseModal = (warehouse) => {
        setSelectedWarehouse(warehouse);
        setIsWarehouseModalOpen(true);
    };

    const closeWarehouseModal = () => {
        setIsWarehouseModalOpen(false);
    };

    const getWarehousesAndProducts = async (id) => {
        try {
            const response = await fetchedWarehousesWithoutProducts({
                subsidiaryID: id,
            });
            setWarehouses(response);
        } catch (error) {
            throw error;
        }
    };

    const getWarehouseCategories = async () => {
        try {
            const response = await fetchedWarehouseCategories();
            setWarehouseCategories(response);
            return response;
        } catch (error) {
            throw error;
        }
    };

    useEffect(() => {
        getWarehouseCategories();
        getWarehousesAndProducts(auth.data.subsidiary.subsidiary_id);
    }, []);

    return (
        <>
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
                        <div>
                            <h1 className="flex items-center gap-2 text-2xl font-bold text-gray-900 dark:text-white">
                                <i
                                    className="fas fa-warehouse text-blue-600 dark:text-blue-400"
                                    aria-hidden="true"
                                />
                                Módulo Logístico
                            </h1>
                            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                                Gestión de almacenes por sede
                            </p>
                        </div>
                        <ol className="flex items-center gap-2 text-sm">
                            <li className="text-blue-600 dark:text-blue-400">
                                <a href="#" className="hover:underline">
                                    Logística
                                </a>
                            </li>
                            <li className="text-gray-500 dark:text-gray-400">/</li>
                            <li className="font-medium text-gray-700 dark:text-gray-300">
                                Almacenes
                            </li>
                        </ol>
                    </div>
                </div>
            </section>

            <section>
                <div className="max-w-full px-4">
                    <Card className="shadow-md">
                        <WarehouseList
                            warehouses={warehouses}
                            setWarehouses={setWarehouses}
                            onOpenWarehouseModal={openWarehouseModal}
                            emptyWarehouse={emptyWarehouse}
                        />
                        <WarehouseRegisterForm
                            isOpen={isWarehouseModalOpen}
                            onClose={closeWarehouseModal}
                            warehouseCategories={warehouseCategories}
                            subsidiaryID={auth.data.subsidiary.subsidiary_id}
                            subsidiaryName={auth.data.subsidiary.name}
                            warehouses={warehouses}
                            setWarehouses={setWarehouses}
                            selectedWarehouse={selectedWarehouse}
                            setSelectedWarehouse={setSelectedWarehouse}
                        />
                    </Card>
                </div>
            </section>
        </>
    );
}
